<div class="overview">
    <div class="overviewitem" *ngFor="let item of items">
        <span [ngStyle]="{'background-color': item.background}" class="item census">{{item.title}}</span>
        <span class="overviewdata">{{item.value}}</span>
    </div>
</div>
